"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createGridKeyAppolloClient = _interopRequireDefault(require("cornerstone_ui_core/lib/utils/createGridKeyAppolloClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const GRAPHQL_BASE_URL = process.env.NODE_ENV === "production" ? "/apollo_gateway/graphql" : (window.localStorage.getItem("devDomain") || "https://cornerstone-dev.elcompanies.net") + "/apollo_gateway/graphql";
var _default = exports.default = (0, _createGridKeyAppolloClient.default)(GRAPHQL_BASE_URL, {
  appName: localStorage.getItem("AppId")
});